import { CountryCode } from '../enum/country-code'
import { Deletable } from '../interface/deletable'
import { Factory } from '../interface/factory'
import { Identifiable } from '../interface/identifiable'
import { Modifiable } from '../interface/modifiable'
import { I18nString } from './i18nstring'
import { Settings } from './settings'
import { applyEntitySchema } from '../../_utils/fcdc-v2'
import { isPlainObject } from '../../_utils/fcdc-v2/json'
import { CountrySchema } from '../schema/owners.schema'

export class Country implements Modifiable, Deletable, Identifiable {
  id: CountryCode
  settings?: Settings
  names: I18nString[]
  deleted?: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.settings = isPlainObject(json.settings)
      ? new Settings(json.settings)
      : undefined
    this.names = Array.isArray(json.names)
      ? json.names.map((name: any) => new I18nString(name))
      : []
    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    applyEntitySchema(this, CountrySchema, json, {
      names: [],
      settings: undefined,
    })
  }

  static getFactory(): Factory<Country> {
    return new (class implements Factory<Country> {
      make(json: any): Country {
        return new Country(json)
      }

      getTableName(): string {
        return 'countries'
      }
    })()
  }

  getCountryName(code: CountryCode): string {
    const countryNames: { [key in CountryCode]: string } = {
      [CountryCode.AL]: 'Albania',
      [CountryCode.AD]: 'Andorra',
      [CountryCode.BE]: 'Belgium',
      [CountryCode.BA]: 'Bosnia and Herzegovina',
      [CountryCode.BG]: 'Bulgaria',
      [CountryCode.CY]: 'Cyprus',
      [CountryCode.DK]: 'Denmark',
      [CountryCode.EE]: 'Estonia',
      [CountryCode.FI]: 'Finland',
      [CountryCode.FR]: 'France',
      [CountryCode.GR]: 'Greece',
      [CountryCode.IE]: 'Ireland',
      [CountryCode.IS]: 'Iceland',
      [CountryCode.IT]: 'Italy',
      [CountryCode.HR]: 'Croatia',
      [CountryCode.LV]: 'Latvia',
      [CountryCode.LI]: 'Liechtenstein',
      [CountryCode.LT]: 'Lithuania',
      [CountryCode.LU]: 'Luxembourg',
      [CountryCode.MT]: 'Malta',
      [CountryCode.MD]: 'Moldova',
      [CountryCode.MC]: 'Monaco',
      [CountryCode.ME]: 'Montenegro',
      [CountryCode.NL]: 'Netherlands',
      [CountryCode.NO]: 'Norway',
      [CountryCode.PL]: 'Poland',
      [CountryCode.PT]: 'Portugal',
      [CountryCode.RO]: 'Romania',
      [CountryCode.RU]: 'Russia',
      [CountryCode.SM]: 'San Marino',
      [CountryCode.CH]: 'Switzerland',
      [CountryCode.RS]: 'Serbia',
      [CountryCode.SK]: 'Slovakia',
      [CountryCode.SI]: 'Slovenia',
      [CountryCode.ES]: 'Spain',
      [CountryCode.GB]: 'United Kingdom',
      [CountryCode.SE]: 'Sweden',
      [CountryCode.CZ]: 'Czech Republic',
      [CountryCode.TR]: 'Turkey',
      [CountryCode.DE]: 'Germany',
      [CountryCode.UA]: 'Ukraine',
      [CountryCode.HU]: 'Hungary',
      [CountryCode.VA]: 'Vatican City',
      [CountryCode.BY]: 'Belarus',
      [CountryCode.AT]: 'Austria',
    }

    return countryNames[code]
  }

  static getUrl(countryId?: string): string {
    return '/countries' + (countryId ? '/' + countryId : '')
  }
}
